import { Box, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Loader } from "../Common/Loader";
import { getUserPlan } from "../Redux/Slice/Plans/GetUserPlanSlice";
import { removeCustomerPlan } from "../Redux/Slice/Plans/RemoveCustomerPlanSlice";
import NoPlanModal from "./NoPlanModal";
import { SuccessModel } from "./SuccessModel";
import { ErrorModel } from "./ErrorModel";
import { ConfirmModel } from "./ConfirmModel";

export const PlanSUmmaryModel = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { userPlanData, loading } = useSelector((state) => state.userPlan);
  const [successModal, setSuccessModal] = useState({
    visible: false,
    message: "",
  });
  const [confirmModel, setConfirmModel] = useState(false);
  const [errorModal, setErrorModal] = useState({
    visible: false,
    message: "",
  });
  const INITIAL_SELECTED_PLAN_STATE = {
    features: [],
    interval: "",
    isTrial: false,
    name: "",
    numberOfCredits: 0,
    price: 0,
  };
  const [selecctedPlan, setselectedPlan] = useState(
    INITIAL_SELECTED_PLAN_STATE
  );

  const onPressRemove = async () => {
    setIsLoading(true);
    const payload = {
      customerId: props?.planId?.id,
    };
    const result = await dispatch(removeCustomerPlan(payload));
    if (
      removeCustomerPlan.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setSuccessModal({
        visible: true,
        message: "Plan removed successfully!",
      });

      setTimeout(() => {
        setSuccessModal({
          visible: false,
          message: "",
        });
        if (props?.onRemove) {
          props.onRemove();
        }
      }, 1500);
    } else {
      setIsLoading(false);
      setErrorModal({
        visible: true,
        message: result?.payload?.error?.message,
      });

      setTimeout(() => {
        setErrorModal({
          visible: false,
          message: "",
        });
      }, 1500);
    }
  };

  useEffect(() => {
    dispatch(getUserPlan(props?.planId?.id));
  }, []);

  useEffect(() => {
    if (userPlanData && userPlanData?.data) {
      setselectedPlan(userPlanData?.data);
    } else {
      setselectedPlan(INITIAL_SELECTED_PLAN_STATE);
    }
  }, [userPlanData]);

  function CircularProgressWithLabel(props) {
    const total = Number(selecctedPlan?.credits); // total steps
    const current = Number(selecctedPlan?.totalCreditsUsed);
    const progressValue = (current / total) * 100;

    return (
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress
          variant="determinate"
          value={progressValue}
          size={65}
          thickness={5}
          sx={{
            color: "#D4001C", // Color of the progress arc
            "& .MuiCircularProgress-circle": {
              strokeLinecap: "round", // Rounded ends of the progress
            },
            // position: 'absolute',
            zIndex: 1,
          }}
        />
        <CircularProgress
          variant="determinate"
          value={100}
          size={65}
          thickness={5}
          sx={{
            color: "#F6CCD2", // Light red for the background track
            position: "absolute",
          }}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
          }}
        >
          <Typography
            variant="body2"
            sx={{ color: "#525252", fontSize: 10, textAlign: "center" }}
          >
            Status
          </Typography>
          <Typography
            variant="h6"
            sx={{ color: "#D4001C", fontSize: 8, textAlign: "center" }}
          >
            {`${current.toString().padStart(2, "0")} of ${total}`}
          </Typography>
        </Box>
      </Box>
    );
  }

  if (loading || isLoading) {
    return <Loader />;
  }

  return successModal.visible ? (
    <SuccessModel message={successModal.message} />
  ) : errorModal.visible ? (
    <ErrorModel message={errorModal.message} />
  ) : !selecctedPlan ||
    !selecctedPlan?.name ||
    !selecctedPlan?.planTypeDetails?.features ? (
    <NoPlanModal
      onClose={props?.onClose}
      onPressAddPlan={() => {
        navigate("/edit-customer/" + props?.planId?.id, {
          state: {
            isNavigateToPlan: true,
          },
        });
      }}
    />
  ) : confirmModel ? (
    <ConfirmModel
      onAccept={onPressRemove}
      onReject={() => setConfirmModel(false)}
      yes={"Yes"}
      no={"No"}
      title="Remove Plan!"
      message="Are you sure you want to remove the plan?"
    />
  ) : (
    <div className="modal modal--planSummery modal--open">
      <div className="modal__dialog">
        <div className="modal__content modal__content--lg">
          <div className="modal__header">
            <h1 className="modal__header--title">Plan Summary</h1>
            <p className="para">Please check your plan details below</p>
            <button
              className="btn btn__transparent btnClose"
              onClick={props.onClose}
            >
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.586914"
                  width="24"
                  height="24"
                  rx="12"
                  fill="#E5E5E5"
                />
                <path
                  d="M12.5869 10.8891L16.476 7L17.5869 8.11094L13.6979 12L17.5869 15.8891L16.476 17L12.5869 13.1109L8.69785 17L7.58691 15.8891L11.476 12L7.58691 8.11094L8.69785 7L12.5869 10.8891Z"
                  fill="#4F4F4F"
                />
              </svg>
            </button>
          </div>
          <div className="modal__body modal-body-left">
            <div className="planSummery">
              <div className="planSummery__header">
                <h2 className="title">
                  Plan Name <span>{selecctedPlan.name}</span>
                </h2>
                <h3 className="price">
                  ${selecctedPlan.price}{" "}
                  <span>/{selecctedPlan.numberOfCredits} Credits</span>
                </h3>
              </div>
              <div className="planSummery__features">
                <h4 className="title">Features</h4>
                <ul className="list">
                  {selecctedPlan && selecctedPlan?.planTypeDetails?.features
                    ? selecctedPlan?.planTypeDetails?.features.map(
                        (feature) => {
                          return (
                            <li>
                              <svg
                                width="15"
                                height="16"
                                viewBox="0 0 15 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.19162 0.808594C5.76925 0.808594 4.37883 1.23037 3.19617 2.0206C2.01352 2.81083 1.09175 3.934 0.547433 5.2481C0.00311601 6.5622 -0.139302 8.00819 0.138188 9.40323C0.415678 10.7983 1.10061 12.0797 2.10638 13.0855C3.11215 14.0912 4.39357 14.7762 5.78861 15.0536C7.18364 15.3311 8.62964 15.1887 9.94374 14.6444C11.2578 14.1001 12.381 13.1783 13.1712 11.9957C13.9615 10.813 14.3832 9.42258 14.3832 8.00021C14.3832 6.09288 13.6256 4.26366 12.2769 2.91497C10.9282 1.56628 9.09896 0.808594 7.19162 0.808594ZM6.16425 10.8717L3.59581 8.30329L4.41258 7.48653L6.16425 9.2382L9.97067 5.43178L10.7905 6.24649L6.16425 10.8717Z"
                                  fill="#8b58f1"
                                />
                              </svg>
                              {feature?.name}
                            </li>
                          );
                        }
                      )
                    : ""}
                </ul>
              </div>
              <div className="planSummery__credit">
                <h4 className="title">
                  Plan Credit{" "}
                  <span className="status status--error ">
                    {Number(selecctedPlan?.credits)}/
                    {Number(selecctedPlan?.credits) -
                      Number(selecctedPlan?.totalCreditsUsed)}{" "}
                    Credits Left
                  </span>
                </h4>
                <div className="creditScore">
                  <CircularProgressWithLabel />
                  <div className="creditScore__detail">
                    <h4 className="title">Credits</h4>
                    <p>
                      Here is the detail of your ending credits. <br />
                      Please purchase a plan to enjoy our services.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal__footer">
            <div className="btn__group">
              <button
                className="btn btn__danger btn__outlined"
                onClick={() => setConfirmModel(true)}
              >
                Remove
              </button>
              <button
                className="btn btn__primary"
                onClick={() =>
                  navigate("/edit-customer/" + props.planId.id, {
                    state: { selectedTab: 3 },
                  })
                }
              >
                Change Plan
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};
